export default __webpack_public_path__ + "static/media/deletedSuccessfully.5f56ec38.png";